import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import UILink from 'UIComponents/link/UILink';
import RevisionOptionComponent from 'automation-ui-canvas/containers/enrollment-history/panel/enrollments-list/RevisionOptionComponent';
import { GET_GROUPED_REVISIONS_FIELD } from 'automation-ui-canvas/containers/enrollment-history/panel/queries/revisionGroupingQueries';
import { mergeNextPageOptions } from 'automation-ui-canvas/containers/enrollment-history/utils/revisionFilterUtils';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const GroupedRevisionsSelect = ({
  revisionOptions,
  onChange,
  value,
  fetchMore,
  hasMore,
  offset
}) => {
  const loadOptions = useCallback((__, callback, pagination) => {
    const {
      optionsOffset,
      currentOptions
    } = pagination !== null && pagination !== void 0 ? pagination : {};
    if (optionsOffset) {
      fetchMore({
        variables: {
          after: optionsOffset,
          lastGroupId: currentOptions[currentOptions.length - 1].groupId
        }
      }).then(({
        data: {
          [GET_GROUPED_REVISIONS_FIELD]: nextPageGroupedRevisionsData = {}
        } = {}
      }) => {
        var _nextOptionsPaging$ne;
        const {
          results: nextPageGroupedRevisionResults,
          paging: nextOptionsPaging
        } = nextPageGroupedRevisionsData;
        const mergedOptions = mergeNextPageOptions(currentOptions, nextPageGroupedRevisionResults);
        callback(null, {
          options: mergedOptions,
          pagination: {
            hasMore: !!(nextOptionsPaging !== null && nextOptionsPaging !== void 0 && nextOptionsPaging.next),
            optionsOffset: nextOptionsPaging === null || nextOptionsPaging === void 0 || (_nextOptionsPaging$ne = nextOptionsPaging.next) === null || _nextOptionsPaging$ne === void 0 ? void 0 : _nextOptionsPaging$ne.after,
            currentOptions: mergedOptions
          }
        });
      }).catch(err => {
        reportError({
          error: err
        });
      });
    } else {
      callback(null, {
        options: revisionOptions,
        pagination: {
          hasMore,
          optionsOffset: offset,
          currentOptions: revisionOptions
        }
      });
    }
  }, [fetchMore, hasMore, revisionOptions, offset]);
  return /*#__PURE__*/_jsx(UISelect, {
    optionComponent: RevisionOptionComponent,
    buttonUse: "form-on-dark",
    value: value,
    loadMoreComponent: /*#__PURE__*/_jsx(UILink, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.enrollmentHistory.panel.selected-enrollment.loadMore"
      })
    }),
    searchable: false,
    placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.enrollmentHistory.panel.enrollment-list.filter.revisionFilter.placeholder"
    }),
    onChange: evt => {
      return onChange(evt.target.value);
    },
    loadOptions: loadOptions
  });
};
export default GroupedRevisionsSelect;